<!-- link-edit-settings.component.html -->
<div *ngIf="form">
	<div class="settings-container">

		<div class="setting-description">
			<div class="setting-label-layout">

				<div class="setting-tool-row">
					<!-- Info -->
					<button type="button" class="tool-btn tool-btn--info" *ngIf="setting.settingDescription" (click)="showDescription()" title="Short setting description" aria-label="Information">
            <i class="far fa-info-circle"></i>
          </button>

					<!-- Help -->
					<button type="button" class="tool-btn tool-btn--help" *ngIf="freshdeskArticleIds?.length" (click)="openIssueHelp()" title="Show article" aria-label="Help">
            <i class="far fa-book"></i>
          </button>
				</div>

				<div class="setting-name">
					{{ setting.displayName.trim() }}
				</div>

			</div>
		</div>

		<!-- RIGHT: control -->
		<div class="setting-field">
			<ng-container [ngSwitch]="setting.dataType" [formGroup]="form">
				<dx-switch *ngSwitchCase="1" class="al-switch" [formControlName]="setting.id" [as-validator]="customErrors"></dx-switch>

				<dx-date-box class="form-control" *ngSwitchCase="2" [formControlName]="setting.id" [as-validator]="customErrors" [value]="setting.useValue" [displayFormat]="dateFormat"></dx-date-box>

				<dx-number-box class="form-control" *ngSwitchCase="3" [formControlName]="setting.id" [as-validator]="customErrors" [value]="setting.useValue"></dx-number-box>

				<dx-number-box class="form-control" *ngSwitchCase="4" [formControlName]="setting.id" [as-validator]="customErrors" [value]="setting.useValue" format="###0"></dx-number-box>

				<dx-button text="open map" (onClick)="showGridMap()" class="form-control" *ngIf="isMapType()"></dx-button>

				<dx-text-box class="form-control" *ngSwitchCase="6" [formControlName]="setting.id" [as-validator]="customErrors" [value]="setting.useValue"></dx-text-box>

				<dx-text-area class="form-control" *ngSwitchCase="7" [formControlName]="setting.id" [as-validator]="customErrors" [value]="setting.useValue"></dx-text-area>

				<dx-lookup class="form-control" *ngSwitchCase="8" [formControlName]="setting.id" [as-validator]="customErrors" [value]="setting.useValue" [dataSource]="dataSourceSubject | async" displayExpr="Value" [showClearButton]="false" valueExpr="Id"></dx-lookup>

				<setting-dropdown *ngSwitchCase="9" [dataSource]="dataSourceSubject | async" [setting]="setting" (valueChanged)="onDropdownSelectionChanged($event)">
				</setting-dropdown>
			</ng-container>
		</div>

	</div>
</div>

<dx-popup style="width: 50vw; height: 50vw" [showTitle]="true" title="Map attributes" [dragEnabled]="false" [hideOnOutsideClick]="false" [showCloseButton]="true" [(visible)]="gridMapVisible">
	<div *dxTemplate="let data of 'content'">
		<div>
			The usage of this map depends on the purpose of the setting, please see the setting description for more information
			<br> For hierarchical object structres use hyphen ('-') to seperate those as in this example: 'parent-child-childofchild'
			<br>
			<dx-data-grid id="gridContainer" [dataSource]="dataSource" [showBorders]="true" (onSaving)="onGridSaving($event)">
				<dxo-editing [allowUpdating]="true" [allowAdding]="isMapEditable()" [allowDeleting]="isMapEditable()" mode="row"></dxo-editing>
				<dxi-column dataField="Key" [allowEditing]="isMapEditable()"></dxi-column>
				<dxi-column dataField="Value"></dxi-column>
			</dx-data-grid>
		</div>
	</div>
</dx-popup>

<!-- ✅ Child help modal lives here -->
<al-freshdesk-help-modal #helpModal></al-freshdesk-help-modal>
